<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppBox from '../../../components/app/box.vue';
  import AppTitleHeader from '../../../components/app/TitleHeader.vue';
  import TriageAnswerMixin from '../../../Mixins/Triage/TriageAnswerMixin';
  import TriageQuestionMixin from '../../../Mixins/Triage/TriageQuestionMixin';

  export default {
    components: {
      AppBox,
      AppTitleHeader,
    },
    mixins: [TriageAnswerMixin, TriageQuestionMixin],
    props: {
      missionId: {
        type: Number,
        default: 0,
      },
    },
    mounted() {
      if (this.missionId) {
        this.getAllTriageAnswersByMissionId(this.missionId);
        this.getAllTriageQuestionsByMissionId(this.missionId);
      }
    },
    methods: {
      answerClassBaseOnRank: function (rank) {
        switch (rank) {
          case 0:
            return 'white-rank';
          case 1:
            return 'green-rank';
          case 2:
            return 'yellow-rank';
          case 3:
            return 'red-rank';

          default:
            return 'white-rank';
        }
      },
    },
    computed: {
      sortedTriageQuestion: function () {
        return [...this.allTriageQuestions]?.sort(
          (a, b) => a?.answer?.priority - b?.answer?.priority,
        );
      },
      sortedTriageAnswer: function () {
        return [...this.allTriageAnswers]?.sort(
          (a, b) => a?.answer?.priority - b?.answer?.priority,
        );
      },
    },
  };
</script>
<template>
  <v-row no-gutters class="pa-4">
    <v-col cols="12">
      <app-title-header title="پرسش های کلیدی" class="mb-4" />
      <app-box
        v-if="sortedTriageQuestion?.length"
        outlined
        max-height="275px"
        class="flex gap-3 flex-col"
      >
        <div
          no-gutters
          v-for="{ id, question } in sortedTriageQuestion"
          :key="id"
          class="flex-gap-1"
        >
          <div cols="1" class="flex-gap-1">
            <div>
              {{ question?.priority }}
            </div>
            <div>.</div>
          </div>
          <div cols="11">
            {{ question?.title }}
          </div>
        </div>
      </app-box>
      <app-box v-else outlined height="275px" class="flex items-center justify-center">
        <div>سوال کلیدی برای نمایش وجود ندارد</div>
      </app-box>
    </v-col>
    <v-col cols="12" class="mt-4">
      <app-title-header title="پاسخ ها" class="mb-4" />
      <app-box v-if="sortedTriageAnswer?.length" outlined class="flex gap-4 flex-col">
        <div
          v-for="{ id, answer } in sortedTriageAnswer"
          :key="id"
          class="flex-gap-1 pa-2 rounded answer-item"
          :class="`${answerClassBaseOnRank(answer?.rank)}`"
        >
          <div>{{ answer?.priority }} .</div>
          <div>
            {{ answer?.title }}
          </div>
        </div>
      </app-box>
      <app-box v-else outlined class="flex items-center justify-center">
        <div>پاسخی برای نمایش وجود ندارد</div>
      </app-box>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
  .green-rank {
    background-color: var(--rank-green-color);
    color: var(--black-color);
  }
  .white-rank {
    background-color: var(--rank-white-color);
    color: var(--black-color);
  }
  .yellow-rank {
    background-color: var(--rank-yellow-color);
    color: var(--black-color);
  }
  .red-rank {
    background-color: var(--rank-red-color);
    color: white;
  }
  .answer-item {
    width: fit-content;
  }
</style>
